export const i18nKeyPrefix = 'MAIN-LEAD'
